import { useQuery } from '@tanstack/react-query';
import { findFirstAction, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
import { GET_PROJECT_ACTIONS } from './actionNames';
export function useGetDLProject({ projectId }) {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    // Owner gets `getDLProject`, Agent gets `getAgentDLProject` — same params and
    // response envelope. The resolved name keys the cache so personas never mix.
    const resolved = user ? findFirstAction(user, GET_PROJECT_ACTIONS) : null;
    return useQuery({
        queryKey: [resolved?.name ?? GET_PROJECT_ACTIONS[0], user?.email, projectId],
        enabled: Boolean(user && resolved && projectId),
        queryFn: async () => {
            if (!user || !resolved)
                throw new Error('getDLProject unavailable');
            const response = await invokeAction(resolved.action, user.token, {
                variables: { UUID: projectId },
            });
            if (!response.ok)
                throw new Error(`${resolved.name} returned ${response.status}`);
            const json = (await response.json());
            const project = json.object;
            if (!project)
                throw new Error(`${resolved.name} response missing object`);
            return project;
        },
    });
}
